import { RequestBase } from '../Base';
import { defaultPaging } from '../common/paging';

export interface Auth2UserSearchRequest extends RequestBase {
    firstName: string,
    lastName: string,
    email: string,
    role: string,
    isActiveOnly: boolean
}

export const defaultAuth2UserSearchRequest: Auth2UserSearchRequest = {
    ...defaultPaging, 
    firstName: '',
    lastName: '',
    email: '',
    role: '',
    isActiveOnly: true
}


export interface CreateUser {
    email: string,
    contactId: number,
}
